import { jsxs as o, jsx as s } from "react/jsx-runtime";
import * as m from "@radix-ui/react-tabs";
import t from "./index.es5846.js";
import { useBaseTabs as n } from "./index.es5624.js";
const l = ({ hasBaseLine: a, children: r, testId: i }) => {
  const e = n().variant === "tertiary";
  return /* @__PURE__ */ o(m.List, { className: t.list, "data-testid": i, children: [
    /* @__PURE__ */ s("div", { children: r }),
    a && e && /* @__PURE__ */ s("div", { className: t.baseLine, tabIndex: -1 })
  ] });
};
export {
  l as BaseTabList
};
//# sourceMappingURL=index.es5625.js.map
